// extracted by mini-css-extract-plugin
export default {"container":"BlogBookmarks_container_pUg1u","link":"BlogBookmarks_link_xHyvm","post":"BlogBookmarks_post_cYThY","infiniteLoading":"BlogBookmarks_infiniteLoading_jOT5n"};